import React, { useCallback, useContext, useEffect } from "react";
import TaxReport from "./Desktop/TaxReport";
import TaxReportMobile from "./Mobile/TaxReportMobile";
import di from "./di/servicelocator";
import holdingDI from "@frameworks/web/components/Reports/HoldingReports/di/servicelocator";
import { useSelector } from "react-redux";
import { getQueryParameterName } from "../../../utils/urlHelper";
import { endDateForTaxBudget, getCurrentIndianFinancialYear, getFinancialYear, getPreviousIndianFinancialYear, isFirstDayOfFinancialYear, previousDay, startDateForTaxBudget, } from "@domains/utils/reportDates";
import moment from "moment";
import ClearTaxBanner from "@frameworks/web/components/Reports/RebrandedReports/TaxReport/ClearTaxBanner";
import TermsAndConditionClearTax from "@frameworks/web/components/Reports/RebrandedReports/TaxReport/TermsAndConditionClearTax";
import { useParams } from "react-router-dom";
import { LoginSource } from "@domains/utils/emtReportCallback";
import { ELoginSource } from "@domains/entities/interfaces/iUserDetails";
import { WebConfigContext } from "@frameworks/web/utils/webConfig";
import TaxHarvestingBanner from "./TaxHarvestingBanner";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import TaxBudgetInfo from "./TaxBudget/TaxBudgetInfo";
import TaxBudgetDisclaimer from "./TaxBudget/TaxBudgetToast";
const TaxMainComponent = () => {
    const webConfig = useContext(WebConfigContext);
    const device = DeviceContext();
    const { loginOrigin } = useParams();
    const salesNativeApp = JSON.parse(localStorage.getItem("sales_native_app"));
    const URLfromDate = getQueryParameterName("fromDate");
    const URLtoDate = getQueryParameterName("toDate");
    const [shimmer, setShimmer] = React.useState(true);
    const [openCalendar, setOpenCalendar] = React.useState(false);
    const [showBand, setShowBand] = React.useState(true);
    const [finYear, setFinYear] = React.useState(getFinancialYear(new Date()));
    const [nextFinYear, setNextFinYear] = React.useState(finYear + 1);
    const [clearTaxTermsAndConditionShow, setClearTaxTermsAndConditionShow] = React.useState(false);
    const [openPopUp, setOpenPopup] = React.useState(false);
    const [isTaxHarvesting, setIsTaxHarvesting] = React.useState(false);
    const initStartDate = useCallback(() => {
        if (new Date(finYear, 3, 1) > new Date())
            return new Date(finYear - 1, 3, 1);
        return new Date(finYear, 3, 1);
    }, []);
    const [startDate, setStartDate] = React.useState(initStartDate());
    const [endDate, setEndDate] = React.useState(previousDay);
    const liesInTaxBudgetDateRange = moment(startDate).isSameOrAfter(startDateForTaxBudget) &&
        moment(endDate).isSameOrBefore(endDateForTaxBudget);
    const taxData = useSelector((state) => state.taxReport.data);
    const taxReportError = useSelector((state) => state === null || state === void 0 ? void 0 : state.taxReport.errorData);
    const emptyValidation = useSelector((state) => state.taxReport.emptyValidation);
    const isImpersonated = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.isImpersonated; });
    const lgnSrc = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.lgnSrc; });
    const { selectedMember } = useSelector((state) => state.FamilyTagging.familyDetails.reducersData);
    useEffect(() => {
        var _a;
        if (startDate && endDate) {
            setShimmer(true);
            let payload;
            if (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode) {
                payload = {
                    fromDate: moment(startDate).format("yyyy-MM-DD"),
                    toDate: moment(endDate).format("yyyy-MM-DD"),
                    accCode: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode,
                };
                (_a = di.taxReport) === null || _a === void 0 ? void 0 : _a.getTaxReportData(payload);
            }
        }
    }, [startDate, endDate, selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode]);
    useEffect(() => {
        di.taxReport.getTaxUnderstandingSectionData();
        holdingDI.holdingReport.getDPIdList();
    }, []);
    useEffect(() => {
        if (taxData.taxDetail.length > 0)
            setShimmer(false);
    }, [taxData]);
    useEffect(() => {
        if ((taxReportError === null || taxReportError === void 0 ? void 0 : taxReportError.isOpen) || (emptyValidation === null || emptyValidation === void 0 ? void 0 : emptyValidation.icon)) {
            setShimmer(false);
        }
    }, [taxReportError === null || taxReportError === void 0 ? void 0 : taxReportError.isOpen, emptyValidation === null || emptyValidation === void 0 ? void 0 : emptyValidation.icon]);
    useEffect(() => {
        setNextFinYear(finYear + 1);
    }, [finYear]);
    React.useEffect(() => {
        let dates;
        let isFirstDayOfFY = isFirstDayOfFinancialYear();
        if (isFirstDayOfFY)
            dates = getPreviousIndianFinancialYear();
        else
            dates = getCurrentIndianFinancialYear();
        if (URLfromDate) {
            setStartDate(new Date(URLfromDate));
            setFinYear(getFinancialYear(new Date(URLfromDate)));
        }
        else {
            setStartDate(dates.startDate.toDate());
            if (isFirstDayOfFY)
                setFinYear(dates.startDate.year());
            else
                setFinYear(new Date().getFullYear());
        }
        if (URLtoDate)
            setEndDate(new Date(URLtoDate));
        else
            setEndDate(dates.endDate.toDate());
    }, [URLfromDate, URLtoDate]);
    return (React.createElement(React.Fragment, null,
        device && (device === null || device === void 0 ? void 0 : device.isDesktop) && (webConfig === null || webConfig === void 0 ? void 0 : webConfig.isTaxHarvesting) && (React.createElement(TaxHarvestingBanner, { onClick: () => {
                setOpenPopup(true);
                setIsTaxHarvesting(true);
            } })),
        loginOrigin !== LoginSource.SALES &&
            !salesNativeApp &&
            !isImpersonated &&
            lgnSrc !== ELoginSource.NESTTRADER &&
            (webConfig === null || webConfig === void 0 ? void 0 : webConfig.showClearTax) && (React.createElement(React.Fragment, null,
            React.createElement(ClearTaxBanner, { clearTaxTermsAndConditionShow: clearTaxTermsAndConditionShow, setClearTaxTermsAndConditionShow: setClearTaxTermsAndConditionShow, startDate: startDate, endDate: endDate }),
            React.createElement(TermsAndConditionClearTax, { clearTaxTermsAndConditionShow: clearTaxTermsAndConditionShow, setClearTaxTermsAndConditionShow: setClearTaxTermsAndConditionShow }))),
        device && (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(TaxReport, { shimmer: shimmer, taxData: taxData, openCalendar: openCalendar, setOpenCalendar: setOpenCalendar, showBand: showBand, setShowBand: setShowBand, finYear: finYear, endDate: endDate, setFinYear: setFinYear, startDate: startDate, setEndDate: setEndDate, setStartDate: setStartDate, taxReportError: taxReportError, emptyValidation: emptyValidation, setNextFinYear: setNextFinYear, nextFinYear: nextFinYear, accCode: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode, openPopUp: openPopUp, setOpenPopup: setOpenPopup, isTaxHarvesting: isTaxHarvesting, setIsTaxHarvesting: setIsTaxHarvesting })) : (React.createElement(TaxReportMobile, { shimmer: shimmer, taxData: taxData, openCalendar: openCalendar, setOpenCalendar: setOpenCalendar, showBand: showBand, setShowBand: setShowBand, finYear: finYear, endDate: endDate, setFinYear: setFinYear, startDate: startDate, setEndDate: setEndDate, setStartDate: setStartDate, taxReportError: taxReportError, emptyValidation: emptyValidation, setNextFinYear: setNextFinYear, nextFinYear: nextFinYear, accCode: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode, openPopUp: openPopUp, setOpenPopup: setOpenPopup, isTaxHarvesting: isTaxHarvesting, setIsTaxHarvesting: setIsTaxHarvesting })),
        React.createElement(TaxBudgetDisclaimer, { liesInTaxBudgetDateRange: liesInTaxBudgetDateRange }),
        React.createElement(TaxBudgetInfo, { liesInTaxBudgetDateRange: liesInTaxBudgetDateRange })));
};
export default TaxMainComponent;
